import React, { useEffect, useState } from 'react'
import Select from 'react-select'

import states from 'lib/states'

const SelectStates = props => {
  const [selectedState, setSelectedState] = useState(null)

  useEffect(() => {
    setSelectedState(props.defaultState || null) 
  }, [props.defaultState])

  const onChange = val => {
    setSelectedState(val.value)
    if (props.onChange) props.onChange(val)
  }

  const options = Object.entries(states).map(([k, v], key) => {
    return { value: k, label: v }
  })

  let val = null
  if (selectedState) {
    val = options.find(opt => opt.value === selectedState)
  }

  return <Select
    id="state"
    value={val}
    onChange={val => onChange(val)}
    options={options}
    placeholder={props.placeholder || "Choose a State"}
    autoFocus={props.autoFocus || false}
    styles={{
      menu: provided => ({ ...provided, zIndex: 9999 })
    }}
  />
}

export default SelectStates